import {Route, Routes} from 'react-router-dom'
import {Registration} from './Components/Registration'
import {ForgotPassword} from './Components/ForgotPassword'
import Login from './Components/Login'
import { OTPVerify } from './Components/OTPverify'
import {AuthLayout} from './AuthLayout'
const AuthPage = () => (
  <Routes>
    {/* <Route element={<AuthLayout />}> */}
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='otpverify' element={<OTPVerify/>} />
      <Route index element={<Login />} />
    {/* </Route> */}
  </Routes>
)
export {AuthPage}